import { useEffect, useState } from "react";
import { adminApi, eur, fmtDate } from "@/lib/adminApi";

const PAY_STATUS = { paid: "Plaćeno", initiated: "Započeto", unpaid: "Neplaćeno", expired: "Isteklo" };

export const DevicePayments = ({ deviceId, askConfirm, runAction }) => {
  const [rows, setRows] = useState(null);
  const load = () => adminApi.get(`/admin/devices/${deviceId}/payments`).then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, [deviceId]); // eslint-disable-line react-hooks/exhaustive-deps

  const refund = (t) => askConfirm({
    title: `Refundiraj ${eur(t.amount_eur)}?`,
    text: "Novac se vraća klijentu preko Stripe-a, a uređaj se ODMAH blokira. Ova radnja je nepovratna.",
    ok: "Refundiraj",
    onOk: () => runAction(() => adminApi.post(`/admin/transactions/${t.session_id}/refund`), "Uplata je refundirana, uređaj je blokiran.").then(load),
  });

  if (!rows) return <p className="text-xs text-muted2">Učitavanje uplata…</p>;
  if (!rows.length) return <p className="text-xs text-muted2" data-testid="payments-empty">Nema uplata za ovaj uređaj.</p>;
  return (
    <div className="flex flex-col gap-2" data-testid="payments-list">
      {rows.map((t) => (
        <div key={t.session_id} className="flex flex-wrap items-center gap-x-4 gap-y-1 rounded-xl border border-line bg-surface p-3 text-xs" data-testid={`payment-row-${t.session_id}`}>
          <span className="text-sm font-bold">{eur(t.amount_eur)}</span>
          <span className="text-txt2">{t.package_id === "lifetime" ? "Doživotno" : "Godišnje"}</span>
          <span className={t.payment_status === "paid" ? "text-emerald-400" : "text-muted2"}>{PAY_STATUS[t.payment_status] || t.payment_status}</span>
          {t.refunded && <span className="rounded bg-errBg px-1.5 py-0.5 font-bold text-err">REFUNDIRANO</span>}
          <span className="text-muted2">{t.email || "—"}</span>
          {t.phone && <a href={`tel:${t.phone}`} className="text-brand">{t.phone}</a>}
          <span className="text-muted2">{fmtDate(t.paid_at || t.created_at)} • {t.source}</span>
          {t.payment_status === "paid" && !t.refunded && (
            <button onClick={() => refund(t)} className="ml-auto rounded-lg border border-red-500/40 px-3 py-1.5 font-semibold text-red-400 transition-colors hover:bg-red-500/10" data-testid={`refund-btn-${t.session_id}`}>Refundiraj</button>
          )}
        </div>
      ))}
    </div>
  );
};
